export function SampleBanner() {
  return (
    <div
      role="note"
      className="border-b border-brand-line bg-brand-accent/10 px-[22px] py-3 text-center text-[12.5px] text-brand-ink lg:px-10"
    >
      <strong className="font-medium">Sample page.</strong> All investor names,
      firms, and deal details below are fictional demonstration data.
    </div>
  );
}